import { ApiPromiseClient } from "../apiClient/ApiClient";
import { MccApi } from "../mccApiWrapper";
import * as dotEnv from "lib/dotEnv";

export async function DownloadFile(
	api: ApiPromiseClient,
	filename: string
): Promise<Blob> {
	return api.Get((p) => p.downloadFile(filename), {
		responseType: "blob",
		headers: {
			Accept: "application/octet-stream,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		},
		// needs a longer timeout
		signal: MccApi.TimeoutAbortSignal(
			parseInt(dotEnv.Get("API_DOWNLOAD_TIMEOUT_MS"))
		),
	});
}

export async function DownloadExcelTemplate(
	api: ApiPromiseClient,
	fileName: string
): Promise<Blob> {
	return api.Get((p) => p.downloadExcelTemplate(fileName), {
		responseType: "blob",
		headers: {
			Accept: "application/octet-stream,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		},
	});
}
